import React from 'react';
import { connect } from 'react-redux';

import Header from './Header';
import Footer from './Footer';

const Layout = props => {

    return (
        <div className="wrapper">
            <Header />

            <div className="content-wrapper" style={{minHeight: '249px'}}>
                <div  className="container"  id="container-return">
                    { props.children }
                </div>
            </div>
            <Footer />
            
        </div>
    );
} 
    
export default connect(null, null)(Layout);
